{
  "as_field": "As",
  "behavior_create_only": "Create new records only",
  "behavior_create_only_caption": "Ignore rows that match existing records",
  "behavior_update_only": "Update existing records only",
  "behavior_update_only_caption": "Skip rows that don't match any existing record",
  "behavior_upsert": "Update existing and create new records",
  "behavior_upsert_caption": "Update matched records and create new records for the rest",
  "check_data_matching": "Check your data matching",
  "check_data_matching_caption": "We matched your columns automatically. Check and adjust if needed.",
  "check_before_you_continue": "Check before you continue",
  "common_settings_caption": "Choose where your data goes and how matching records are updated.",
  "custom_tables_setup": "Mapping required",
  "custom_tables_setup_title": "Custom tables setup",
  "custom_tables_setup_caption": "Choose at least one key identifier for each custom table",
  "identify_by": "identify by",
  "choose_fallback_currency": "We couldn’t determine the currency for some records. Please select a default currency that will be applied to those records",
  "choose_behaviour": "Choose behaviour",
  "choose_salary_period": "Choose additional period setting for \"Compensation\"",
  "count_columns_imported": "{columns} will be imported",
  "create_new_import": "Create new import",
  "create_new_values": "Create new",
  "create_new_values_caption": "New values will be created",
  "current_value": "Current value",
  "destination_in": "Destination in %APP_NAME%",
  "empty_state_description": "Import data from a file to quickly populate the system and get started",
  "empty_state_title": "Start with your first import",
  "error_compensation_missing_effective_date": "Compensation effective date is missing",
  "error_custom_table_missing_effective_date": "Custom table effective date is missing",
  "error_employee_already_exists": "Employee already exists",
  "error_employee_identifier_missing": "Employee identifier is missing",
  "error_employee_not_found": "Employee not found",
  "error_employee_update_skipped": "Employee update skipped",
  "error_employment_missing_effective_date": "Employment effective date is missing",
  "error_invalid_data": "Invalid data",
  "error_position_missing_effective_date": "Position effective date is missing",
  "error_required_fields_missing": "Required fields are missing",
  "exclude_column": "Exclude column",
  "exclude_field": "Exclude field",
  "file_column": "File column",
  "file_info": "File info",
  "file_preview": "Your file preview",
  "file_uploaded_ready": "File is uploaded and ready to be mapped!",
  "found_columns": "We found {count_columns} in your file. On next step you will match them to fields in system",
  "how_data_matched": "How your data is matched",
  "how_to_handle_new_records": "How to handle new records",
  "how_to_handle_new_records_caption": "Decide what happens to rows that don't match any existing record",
  "how_to_match_records": "How to match existing records",
  "how_to_match_records_caption": "Choose how we identify existing employees or time-off related data",
  "default_update_method": "Default update method",
  "default_update_method_caption": "Choose how values are written when a row matches an existing record. You override this setting for selected fields on next step",
  "update_only_if_empty": "Only if empty",
  "update_only_if_empty_caption": "Fill only fields that are currently blank",
  "update_always": "Always",
  "update_always_caption": "Replace existing values with data from your file",
  "unrecognized_currencies": "Unrecognized currencies",
  "unrecognized_currencies_substituted": "Unrecognized currencies will be substituted with {currency}",
  "substitute_them_with": "Substitute them with",
  "destination": "Destination",
  "destination_caption": "Select the table to import into",
  "destination_table": "Destination table",
  "download_template_title": "Download a template",
  "download_template_caption": "Fill it in and your data will match %APP_NAME%'s format",
  "import_complete": "Import complete",
  "import_complete_caption": "Your data import has been initiated",
  "import_data": "Import data",
  "import_data_title": "Import data",
  "import_data_to_system": "Import data to system",
  "import_errors": "Import errors",
  "import_in_progress": "Import in progress",
  "import_in_progress_description": "Your data is on its way into our system. You can close this page — we'll finish it in the background.",
  "import_mode": "Import mode",
  "import_processing_message": "Your data is being processed. You can check the progress on the import data page",
  "import_started_successfully": "Import started successfully!",
  "import_to": "Import to",
  "importing_to": "Importing to",
  "include_column": "Include column",
  "include_field": "Include field",
  "and_others": "and others",
  "invalid_values_warning": "We couldn't recognize {records}. Example: {samples}",
  "invalid_values_for_field_type": "Invalid values found for field type",
  "invalid_values_found": "Invalid values found",
  "invalid_values_will_be_skipped": "You can fix it in the file you are importing, or do nothing; invalid values will be skipped during import",
  "maps_to": "Maps to",
  "match_by": "Match by",
  "match_by_field": "Match by field",
  "new_records": "New records",
  "new_values_detected": "New values detected",
  "new_values_will_be_created": "New values detected, they will be created during import",
  "new_values_will_be_skipped": "New values detected, they will be skipped during import",
  "new_value": "New value",
  "new_value_in_directory": "New value in directory",
  "no_data_found_in_file": "No data found in the file for import",
  "match_summary": "Import <strong>{import_type}</strong> match by <strong>{match_by}</strong>. We will <strong>{behavior}</strong>",
  "preset_choice_title": "Start import",
  "preset_choice_caption": "Select data you want to import",
  "preset_additional_compensation_create_caption": "Add new additional compensation records for employees",
  "preset_additional_compensation_create_title": "Add additional compensations",
  "preset_additional_compensation_update_caption": "Update existing additional compensation records",
  "preset_additional_compensation_update_title": "Update additional compensations",
  "preset_compensation_create_caption": "Add new compensation records for employees",
  "preset_compensation_create_title": "Add compensations",
  "preset_compensation_update_caption": "Update existing compensation records",
  "preset_compensation_update_title": "Update compensations",
  "preset_custom_table_create_caption": "Add new records to custom tables",
  "preset_custom_table_create_title": "Add custom table records",
  "preset_custom_table_update_caption": "Update existing custom table records",
  "preset_custom_table_update_title": "Update custom table records",
  "preset_employee_create_caption": "Add new employees to the system",
  "preset_employee_create_title": "Add employees",
  "preset_employee_update_caption": "Update existing employee profiles",
  "preset_employee_update_title": "Update employees",
  "preset_employment_create_caption": "Add new employment records for employees",
  "preset_employment_create_title": "Add employments",
  "preset_employment_update_caption": "Update existing employment records",
  "preset_employment_update_title": "Update employments",
  "preset_position_create_caption": "Add new position records for employees",
  "preset_position_create_title": "Add positions",
  "preset_position_update_caption": "Update existing position records",
  "preset_position_update_title": "Update positions",
  "preset_time_off_balances_upsert_caption": "Add amounts to people's balances as of the beginning of the current cycle",
  "preset_time_off_balances_upsert_title": "Import balances",
  "preset_time_off_history_upsert_caption": "Add new time off history records",
  "preset_time_off_history_upsert_title": "Import time off history",
  "preview_import": "Preview import",
  "ready_to_import": "Ready to import",
  "ready_to_import_caption": "Make sure everything looks correct before you start",
  "records": "Records",
  "row_number": "Row {number}",
  "rows_imported": "Rows imported",
  "samples": "ex. {list}",
  "select_at_least_one_column": "Please select at least one column to import",
  "setup_field_type": "Setup \"{field}\" field type",
  "skip_new_records": "Skip creation",
  "skip_new_records_caption": "Changes will be ignored",
  "update_as": "Update",
  "update_mode": "Update mode",
  "updated_records": "Updated records",
  "upload_file_caption": "You can import data into employee profiles or the time-off system",
  "upload_file_first": "Please upload a file first",
  "upload_file_here": "Upload your file with data here",
  "upload_file_title": "Upload file",
  "values_dont_exist": "{values} don’t exist in \"{column}\"",
  "view_results": "View results",
  "wait_for_parsing": "Please wait for parsing results",
  "validation_error_add_field": "To import \"{column}\" as \"{field}\", you need to add {required_field}",
  "validation_error_missing_field": "Missing required field: {field}"
}
